import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SelectService {

    wmsPrioritiesSelect(): any[] {
        return [
            { value: 4, label: 'very_low', color: 'info' },
            { value: 3, label: 'low', color: 'secondary' },
            { value: 2, label: 'normal', color: 'success' },
            { value: 1, label: 'high', color: 'warning' },
            { value: 0, label: 'urgent', color: 'danger' },
        ]
    }

    pickingDifficultiesSelect(): any[] {
        return [
            { value: 2, label: 'easy', color: 'success' },
            { value: 1, label: 'medium', color: 'warning' },
            { value: 0, label: 'hard', color: 'danger' },
        ]
    }

    pickingStatusesSelect(): { value: string, step: string }[] {
        // return [
        //     // 'sending',
        //     // 'send',
        //     'prepare',
        //     'to_pick',
        //     'picking_in_progress',
        //     'to_validate',
        //     'not_validated',
        //     'validated',
        //     // 'wms_released',
        //     // 'wms_waiting',
        //     // 'wms_release',
        //     // 'wms_working',
        //     // 'wms_partially_closed',
        //     // 'wms_préparé',
        //     // 'wms_closed',
        //     // 'wms_stockfailure',
        //     // 'wms_cancelled',
        //     // 'loading_in_progress',
        //     // 'loaded',
        //     // 'out_for_delivery',
        //     // 'delivered',
        // ].map((value) => ({ value }));

        return [
            {value: 'prepare', step: '1'},
            {value: 'to_pick', step: '2'},
            {value: 'picking_in_progress', step: '3'},
            {value: 'to_validate', step: '4'},
            {value: 'not_validated', step: '4'},
            {value: 'validated', step: '5'},
            {value: 'cancelled', step: 'X'}
        ]
    }

    orderTypesSelect(): any[] {
        return [
            {value: 'scheduled', color: 'warning'},
            {value: 'to_deliver', color: 'dark'},
            {value: 'with_next_order', color: 'success'},
            {value: 'to_install', color: 'info'},
            {value: 'to_install', color: 'danger'},
        ]
    }

    orderStatusSelect(): any[] {
        return [
            {value: 'to_prepare', color: 'info'},
            {value: 'processing', color: 'warning'},
            {value: 'completed', color: 'success'},
            {value: 'canceled', color: 'danger'},
        ]
    }

    consignmentProductStatusSelect(params: { view?: string } = {}): any[] {
        const statuses = [
            {value: 'ordered', view: 'active'},
            {value: 'in_progress', view: 'active'},
            {value: 'pending_return', view: 'active'},
            {value: 'invoiced', view: 'history'},
            {value: 'returned', view: 'history'},
            {value: 'transferred', view: 'history'},
        ];

        if (params.view === 'active' || params.view === 'history') {
            return statuses.filter((status) => status.view === params.view);
        }

        return statuses;
    }

    customerTypesSelect(): any[] {
        return [
            {value: 'private' },
            {value: 'pro' },
        ]
    }

    booleanSelect(): any[] {
        return [
            {value: true, label: 'yes' },
            {value: false, label: 'no'},
        ];
    }

    transferStatusSelect(): any[] {
        return [
            {value: 'draft' },
            {value: 'sending' },
            {value: 'send' },
            {value: 'cancel' },
            {value: 'wms_waiting' },
            {value: 'wms_working' },
            {value: 'wms_stockfailure' },
            {value: 'wms_release' },
        ];
    }

    stInventoryStatusSelect(): any[] {
        return [
            {value: 'sent', color: 'warning'},
            {value: 'received', color: 'success'},
        ];
    }

    customerAddressAccessibilitySelect(): any[] {
        return [
            {value: 'truck'},
            {value: 'smalltruck'},
        ]
    }

    workOrderLocationCodes(): any[] {
        return [
            {value: 'KIT_BUREAU'},
            {value: 'KIT_CONTROLE'},
        ];
    }

    packingLocationCodes(): any[] {
        return [
            {value: 'EMBALLAGE_MIX'},
            {value: 'EMBALLAGE_BAC'},
        ];
    }

    invoiceBillingTypesSelect(): any[] {
        return [
            {value: 'invoice'},
            {value: 'credit_note'},
        ];
    }

    invoiceStatusesSelect(): any[] {
        return [
            {value: 'draft'},
            {value: 'finalized'},
            {value: 'validated'},
            {value: 'sent'},
        ];
    }

    invoiceGroupingModesSelect() {
        return [
            {value: 'by_delivery'},
            {value: 'by_order'},
        ]
    }

    //TODO: get from API enum (and use key to translate)
    supplyOrderStatusesSelect(): any[] {
        return [
            { value: 'in_progress', label: 'Brouillon' },
            { value: 'sent_to_supplier', label: 'Envoyée au fournisseur' },
            { value: 'confirmed_by_supplier', label: 'Confirmée par le fournisseur' },
            { value: 'reception_in_progress', label: 'Réception en cours' },
            { value: 'received', label: 'Reçue' },
            { value: 'partial_receipt_order', label: 'Solde de commande' },
            { value: 'partially_received', label: 'Partiellement reçue' },
            { value: 'receipt_order', label: 'Préavis de réception' },
            { value: 'canceled', label: 'Annulée' },
            { value: 'astral_closed', label: 'Fermée Astral' },
        ];
    }

    orderDeliveryTypesSelect(): any[] {
        return [
            {value: 'waiting_free'},
            {value: 'call_off'},
            {value: 'delivery_date'},
        ]
    }

    waveEquipmentTypesSelect(): any[] {
        return [
            {value: 'ch', label: 'words.trolley'},
            {value: 'tr', label: 'words.pallet_truck'},
        ]
    }

    plannedLoadDateTypes(): any[] {
        return [
            {value: 'day_of_delivery'},
            {value: 'previous_day_of_delivery'},
        ]
    }

    stockMovementMoveableTypes(): any[] {
        return [
            {value: "App\\Models\\SaPickingLine"},
            {value: 'App\\Models\\StStockLine'},
            {value: 'App\\Models\\SaReturnLine'},
            {value: 'App\\Models\\SuReceiptLine'},
            {value: 'App\\Models\\StStockAdjustment'},
            {value: 'kit_adjustment'},
        ];
    }
}
